"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("@apollo/client"),n=e.gql`
  query foundationsExperiments(
    $pageReferer: String!
    $pageUrl: String!
    $experimentNames: [String!]!
  ) {
    experiments(
      pageReferer: $pageReferer
      pageUrl: $pageUrl
      experimentNames: $experimentNames
    ) {
      id
      name
      assignmentType
      isDisabled
      treatment {
        name
        id
      }
    }
  }
`;exports.FoundationsExperimentsDocument=n;
